/*
 * Copyright © 2020-2022 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: caoran
 * @LastEditTime: 2025-04-01 11:07:50
 */
import React, { useEffect, useMemo, useRef } from 'react'
import { Button, Badge } from 'antd'
import {
  useAppDispatch,
  useAppSelector,
  usePathValue
} from '../../../../app/hooks'
import sensors, { sensorsRole } from '../../../../utils/sensors'
import crown_btn_icon from '../../../../images/btn-crown-icon.png'
import {
  setDownloadSettingModalVisible,
  setPaymentVisible
} from '../../../../actions/main'
import { SettingOutlined } from '@ant-design/icons'

const Footer = (props) => {
  const { namingRule, onCancel, onOk } = props
  const dispatch = useAppDispatch()
  const isDesktop = useAppSelector((state) => state.main.isDesktop)
  const groupID = useAppSelector((state) => state.group.groupId)
  const isVip = useAppSelector((state) => state.group.isVip)
  const pathValue = usePathValue()
  const isVipRef = useRef(isVip)

  const onPay = () => {
    sensors.track('web_click_button_workgroup_go_vip_trigger', {
      place: pathValue,
      functionType: 'photoDownload',
      groupID
    })

    dispatch(setPaymentVisible(true, 'photoFolderDownloadPhoto'))
  }

  const handleOpenDownloadSetting = () => {
    dispatch(setDownloadSettingModalVisible(true))
  }

  const handleOKClick = () => {
    if (isVip) {
      onOk()
    } else {
      onPay()
    }
  }

  useEffect(() => {
    if (isVip && isVipRef.current !== isVip) {
      onOk()
    }
    isVipRef.current = isVip
  }, [isVip])

  return (
    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
      <span>
        {isDesktop && (
          <Button onClick={handleOpenDownloadSetting}>
            <SettingOutlined />
            默认下载位置
          </Button>
        )}
      </span>
      <span>
        <Button onClick={onCancel}>取消</Button>
        <Button
          type="primary"
          disabled={namingRule.length === 0}
          onClick={handleOKClick}
          style={{
            marginLeft: 8,
            display: 'inline-flex',
            alignItems: 'center'
          }}
        >
          下载
          <img
            style={{ width: 20, marginLeft: 8 }}
            src={crown_btn_icon}
            alt=""
          />
        </Button>
      </span>
    </div>
  )
}

export default Footer
